import React, { useState, useEffect } from 'react';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { format, subDays, startOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';

const COP = (n) => new Intl.NumberFormat('es-CO', { maximumFractionDigits: 3 }).format(Number(n) || 0);
const hoy = format(new Date(), 'yyyy-MM-dd');

export default function MateriaPrima() {
  const [tab, setTab] = useState('recepciones');

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>📦 Materia Prima</h1>
        <p style={{ margin: '4px 0 0', color: '#6B7280', fontSize: 14 }}>Recepción, stock actual y registro de consumo</p>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', borderBottom: '2px solid #E5E7EB', marginBottom: 20 }}>
        {[
          { id: 'facturas',    label: '🧾 Facturas' },
          { id: 'recepciones', label: '📥 Recepciones' },
          { id: 'stock',       label: '📊 Stock actual' },
          { id: 'consumo',     label: '📉 Registro de consumo' },
          { id: 'catalogo',    label: '🗂️ Catálogo de ítems' },
          { id: 'proveedores', label: '🏭 Proveedores' },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: '10px 22px', border: 'none', cursor: 'pointer', fontSize: 13, background: 'transparent',
            fontWeight: tab === t.id ? 800 : 500,
            color: tab === t.id ? '#1a1a2e' : '#6B7280',
            borderBottom: tab === t.id ? '2px solid #1a1a2e' : '2px solid transparent',
            marginBottom: -2,
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'facturas'    && <TabFacturas />}
      {tab === 'proveedores' && <TabProveedores />}
      {tab === 'recepciones' && <TabRecepciones />}
      {tab === 'stock'       && <TabStock />}
      {tab === 'consumo'     && <TabConsumo />}
      {tab === 'catalogo'    && <TabCatalogo />}
    </div>
  );
}

// ── TAB RECEPCIONES ──────────────────────────────────────
function TabRecepciones() {
  const [items, setItems]           = useState([]);
  const [recepciones, setRecepciones] = useState([]);
  const [cargando, setCargando]     = useState(false);
  const [desde, setDesde]           = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'));
  const [hasta, setHasta]           = useState(hoy);
  const [modal, setModal]           = useState(false);
  const [form, setForm]             = useState({ fecha: hoy, proveedor: '', lote: '', item_id: '', cantidad: '', notas: '' });
  const [guardando, setGuardando]   = useState(false);

  useEffect(() => { API.get('/mp/items').then(r => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => { cargar(); }, [desde, hasta]);

  const cargar = () => {
    setCargando(true);
    API.get('/mp/recepciones', { params: { desde, hasta } })
      .then(r => setRecepciones(r.data))
      .catch(() => toast.error('Error cargando recepciones'))
      .finally(() => setCargando(false));
  };

  const handleGuardar = async () => {
    if (!form.proveedor.trim()) { toast.error('El proveedor es obligatorio'); return; }
    if (!form.item_id) { toast.error('Selecciona un ítem'); return; }
    if (!form.cantidad || parseFloat(form.cantidad) <= 0) { toast.error('Cantidad inválida'); return; }
    setGuardando(true);
    try {
      await API.post('/mp/recepciones', form);
      toast.success('✅ Recepción registrada');
      setModal(false);
      setForm({ fecha: hoy, proveedor: '', lote: '', item_id: '', cantidad: '', notas: '' });
      cargar();
    } catch(e) { toast.error(e.response?.data?.error || 'Error guardando'); }
    finally { setGuardando(false); }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Eliminar este registro? Se revertirá el stock.')) return;
    try {
      await API.delete(`/mp/recepciones/${id}`);
      toast.success('Registro eliminado');
      cargar();
    } catch { toast.error('Error eliminando'); }
  };

  // Agrupar por fecha
  const porFecha = {};
  recepciones.forEach(r => {
    const k = r.fecha.slice(0,10);
    if (!porFecha[k]) porFecha[k] = [];
    porFecha[k].push(r);
  });

  return (
    <div>
      {/* Filtros */}
      <div style={{ background: 'white', borderRadius: 14, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <div style={st.label}>Desde</div>
          <input type="date" value={desde} onChange={e => setDesde(e.target.value)} max={hasta} style={st.input} />
        </div>
        <div>
          <div style={st.label}>Hasta</div>
          <input type="date" value={hasta} onChange={e => setHasta(e.target.value)} max={hoy} style={st.input} />
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          {[
            { label: 'Hoy', fn: () => { setDesde(hoy); setHasta(hoy); } },
            { label: 'Este mes', fn: () => { setDesde(format(startOfMonth(new Date()), 'yyyy-MM-dd')); setHasta(hoy); } },
          ].map(a => (
            <button key={a.label} onClick={a.fn} style={{ padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#6B7280' }}>{a.label}</button>
          ))}
        </div>
        <button onClick={() => setModal(true)} style={{ marginLeft: 'auto', padding: '9px 20px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#059669,#047857)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
          ➕ Nueva recepción
        </button>
      </div>

      {/* Lista agrupada por fecha */}
      {cargando ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>⏳ Cargando...</div>
      ) : Object.keys(porFecha).length === 0 ? (
        <div style={{ background: 'white', borderRadius: 14, padding: 40, textAlign: 'center', color: '#9CA3AF', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          Sin recepciones en este período
        </div>
      ) : (
        Object.keys(porFecha).sort().reverse().map(fecha => (
          <div key={fecha} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
            <div style={{ background: '#1a1a2e', padding: '10px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800, fontSize: 13 }}>
                📅 {format(new Date(fecha + 'T12:00'), "d 'de' MMMM yyyy", { locale: es })}
              </span>
              <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>{porFecha[fecha].length} ítem(s)</span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Ítem', 'Categoría', 'Proveedor', 'Lote', 'Cantidad', 'Registrado por', ''].map(h => (
                    <th key={h} style={{ padding: '9px 14px', textAlign: h === 'Cantidad' ? 'right' : 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {porFecha[fecha].map((r, i) => (
                  <tr key={r.id} style={{ borderTop: '1px solid #F3F4F6', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                    <td style={{ padding: '10px 14px', fontWeight: 600 }}>{r.item_nombre}</td>
                    <td style={{ padding: '10px 14px', color: '#6B7280', fontSize: 12 }}>{r.categoria}</td>
                    <td style={{ padding: '10px 14px', color: '#374151' }}>{r.proveedor}</td>
                    <td style={{ padding: '10px 14px', color: '#6B7280', fontSize: 12 }}>{r.lote || '—'}</td>
                    <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700, color: '#059669' }}>
                      {COP(r.cantidad)} {r.item_unidad}
                    </td>
                    <td style={{ padding: '10px 14px', color: '#6B7280', fontSize: 12 }}>{r.registrado_por_nombre}</td>
                    <td style={{ padding: '10px 14px' }}>
                      <button onClick={() => handleEliminar(r.id)}
                        style={{ padding: '4px 10px', border: '1px solid #FCA5A5', borderRadius: 6, background: '#FEF2F2', cursor: 'pointer', fontSize: 11, color: '#DC2626', fontWeight: 600 }}>
                        🗑
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {porFecha[fecha][0]?.notas && (
              <div style={{ padding: '8px 14px', background: '#F9FAFB', fontSize: 12, color: '#6B7280', borderTop: '1px solid #F3F4F6' }}>
                <strong>Notas:</strong> {porFecha[fecha][0].notas}
              </div>
            )}
          </div>
        ))
      )}

      {/* Modal nueva recepción */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: 480, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 20 }}>📥 Nueva recepción de materia prima</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
              <div>
                <div style={st.label}>Fecha de recepción</div>
                <input type="date" value={form.fecha} onChange={e => setForm(f => ({ ...f, fecha: e.target.value }))} max={hoy} style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={st.label}>Proveedor</div>
                <input value={form.proveedor} onChange={e => setForm(f => ({ ...f, proveedor: e.target.value }))} placeholder="Nombre del proveedor" autoFocus style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={st.label}>Ítem / Materia prima</div>
              <select value={form.item_id} onChange={e => setForm(f => ({ ...f, item_id: e.target.value }))} style={{ ...st.input, width: '100%', boxSizing: 'border-box' }}>
                <option value="">Seleccionar ítem...</option>
                {Object.entries(
                  items.reduce((g, i) => { (g[i.categoria] = g[i.categoria] || []).push(i); return g; }, {})
                ).map(([cat, its]) => (
                  <optgroup key={cat} label={cat}>
                    {its.map(i => <option key={i.id} value={i.id}>{i.nombre} ({i.unidad})</option>)}
                  </optgroup>
                ))}
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
              <div>
                <div style={st.label}>Cantidad</div>
                <input type="number" value={form.cantidad} onChange={e => setForm(f => ({ ...f, cantidad: e.target.value }))} placeholder="0" style={{ ...st.input, width: '100%', boxSizing: 'border-box', fontFamily: 'monospace' }} />
              </div>
              <div>
                <div style={st.label}>Lote (opcional)</div>
                <input value={form.lote} onChange={e => setForm(f => ({ ...f, lote: e.target.value }))} placeholder="Ej: LOT-2026-001" style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ marginBottom: 20 }}>
              <div style={st.label}>Notas (opcional)</div>
              <textarea value={form.notas} onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} placeholder="Observaciones adicionales..." rows={2} style={{ ...st.input, width: '100%', boxSizing: 'border-box', resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setModal(false)} style={{ padding: '9px 18px', border: '2px solid #E5E7EB', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#6B7280' }}>Cancelar</button>
              <button onClick={handleGuardar} disabled={guardando} style={{ padding: '9px 20px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#059669,#047857)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {guardando ? '⏳ Guardando...' : '✅ Registrar entrada'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── TAB STOCK ────────────────────────────────────────────
function TabStock() {
  const [stock, setStock]     = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    setCargando(true);
    API.get('/mp/stock')
      .then(r => setStock(r.data))
      .catch(() => toast.error('Error cargando stock'))
      .finally(() => setCargando(false));
  }, []);

  const categorias = [...new Set(stock.map(s => s.categoria))].sort();
  const filtrado = stock.filter(s => !busqueda || s.nombre.toLowerCase().includes(busqueda.toLowerCase()) || s.categoria.toLowerCase().includes(busqueda.toLowerCase()));

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input placeholder="🔍 Buscar ítem..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ ...st.input, flex: 1 }} />
        <div style={{ fontSize: 12, color: '#6B7280', background: '#F9FAFB', padding: '8px 14px', borderRadius: 8 }}>
          {stock.length} ítems · Stock actualizado al último inventario + entradas
        </div>
      </div>

      {cargando ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>⏳ Cargando...</div>
      ) : (
        categorias.map(cat => {
          const its = filtrado.filter(s => s.categoria === cat);
          if (!its.length) return null;
          return (
            <div key={cat} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
              <div style={{ background: '#F3F4F6', padding: '10px 18px', fontWeight: 700, fontSize: 13, color: '#374151', borderBottom: '1px solid #E5E7EB' }}>
                📁 {cat} <span style={{ fontWeight: 400, color: '#9CA3AF', fontSize: 12 }}>({its.length} ítems)</span>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Código', 'Ítem', 'Unidad', 'Stock actual', 'Costo prom.', 'Última actualización'].map(h => (
                      <th key={h} style={{ padding: '9px 14px', textAlign: ['Stock actual','Costo prom.'].includes(h) ? 'right' : 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {its.map((s, i) => (
                    <tr key={s.id} style={{ borderTop: '1px solid #F3F4F6', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                      <td style={{ padding: '9px 14px', color: '#9CA3AF', fontSize: 12, fontFamily: 'monospace' }}>{s.codigo || '—'}</td>
                      <td style={{ padding: '9px 14px', fontWeight: 600 }}>{s.nombre}</td>
                      <td style={{ padding: '9px 14px', color: '#6B7280' }}>{s.unidad}</td>
                      <td style={{ padding: '9px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, fontSize: 15, color: parseFloat(s.stock) > 0 ? '#059669' : '#EF4444' }}>
                        {COP(s.stock)}
                        </td>
                        <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', color: '#2563EB', fontSize: 13 }}>
                          {s.costo_promedio > 0 ? `$${new Intl.NumberFormat('es-CO').format(parseFloat(s.costo_promedio).toFixed(2))}` : '—'}
                      </td>
                      <td style={{ padding: '9px 14px', color: '#9CA3AF', fontSize: 12 }}>
                        {s.ultima_actualizacion ? format(new Date(s.ultima_actualizacion), "d MMM yyyy HH:mm", { locale: es }) : '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })
      )}
    </div>
  );
}

// ── TAB CONSUMO ──────────────────────────────────────────
function TabConsumo() {
  const [consumo, setConsumo]   = useState([]);
  const [cargando, setCargando] = useState(false);
  const [desde, setDesde]       = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'));
  const [hasta, setHasta]       = useState(hoy);

  useEffect(() => { cargar(); }, [desde, hasta]);

  const cargar = () => {
    setCargando(true);
    API.get('/mp/consumo', { params: { desde, hasta } })
      .then(r => setConsumo(r.data))
      .catch(() => toast.error('Error cargando consumo'))
      .finally(() => setCargando(false));
  };

  const categorias = [...new Set(consumo.map(c => c.categoria))].sort();

  return (
    <div>
      <div style={{ background: 'white', borderRadius: 14, padding: '14px 18px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 16, display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <div style={st.label}>Desde</div>
          <input type="date" value={desde} onChange={e => setDesde(e.target.value)} max={hasta} style={st.input} />
        </div>
        <div>
          <div style={st.label}>Hasta</div>
          <input type="date" value={hasta} onChange={e => setHasta(e.target.value)} max={hoy} style={st.input} />
        </div>
        <div style={{ fontSize: 12, color: '#6B7280', background: '#FEF3C7', padding: '8px 14px', borderRadius: 8, alignSelf: 'center' }}>
          💡 El consumo se calcula al hacer inventario físico en Inventario Producción
        </div>
      </div>

      {cargando ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>⏳ Cargando...</div>
      ) : consumo.length === 0 ? (
        <div style={{ background: 'white', borderRadius: 14, padding: 40, textAlign: 'center', color: '#9CA3AF', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
          Sin registros de consumo en este período
        </div>
      ) : (
        categorias.map(cat => {
          const its = consumo.filter(c => c.categoria === cat);
          return (
            <div key={cat} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
              <div style={{ background: '#F3F4F6', padding: '10px 18px', fontWeight: 700, fontSize: 13, color: '#374151', borderBottom: '1px solid #E5E7EB' }}>
                📁 {cat}
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Fecha inventario', 'Ítem', 'Stock anterior', 'Entradas período', 'Stock esperado', 'Stock real', 'Consumo'].map(h => (
                      <th key={h} style={{ padding: '9px 12px', textAlign: h === 'Ítem' || h === 'Fecha inventario' ? 'left' : 'right', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {its.map((c, i) => (
                    <tr key={c.id} style={{ borderTop: '1px solid #F3F4F6', background: i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                      <td style={{ padding: '9px 12px', color: '#6B7280', fontSize: 12, whiteSpace: 'nowrap' }}>
                        {c.fecha_inventario
                          ? (() => { try { return format(new Date(c.fecha_inventario.slice(0,10) + 'T12:00'), "d MMM yyyy", { locale: es }); } catch { return c.fecha_inventario.slice(0,10); } })()
                          : '—'}
                      </td>
                      <td style={{ padding: '9px 12px', fontWeight: 600 }}>{c.item_nombre}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', color: '#6B7280' }}>{COP(c.stock_anterior)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', color: '#059669' }}>+{COP(c.entradas_periodo)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', color: '#374151' }}>{COP(c.stock_esperado)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700 }}>{COP(c.stock_real)} {c.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: parseFloat(c.consumo) > 0 ? '#EF4444' : '#059669' }}>
                        {parseFloat(c.consumo) > 0 ? '-' : '+'}{COP(Math.abs(c.consumo))} {c.unidad}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })
      )}
    </div>
  );
}

// ── TAB CATÁLOGO ─────────────────────────────────────────
function TabCatalogo() {
  const [items, setItems]       = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [modal, setModal]       = useState(null);
  const [form, setForm]         = useState({ codigo: '', categoria: '', nombre: '', unidad: '' });
  const [guardando, setGuardando] = useState(false);

  const cargar = () => API.get('/mp/items').then(r => setItems(r.data)).catch(() => {});
  useEffect(() => { cargar(); }, []);

  const categorias = [...new Set(items.map(i => i.categoria))].sort();

  const abrirModal = (item) => {
    setForm(item ? { codigo: item.codigo || '', categoria: item.categoria, nombre: item.nombre, unidad: item.unidad } : { codigo: '', categoria: '', nombre: '', unidad: '' });
    setModal(item || 'nuevo');
  };

  const handleGuardar = async () => {
    if (!form.nombre.trim()) { toast.error('El nombre es obligatorio'); return; }
    if (!form.categoria.trim()) { toast.error('La categoría es obligatoria'); return; }
    if (!form.unidad.trim()) { toast.error('La unidad es obligatoria'); return; }
    setGuardando(true);
    try {
      if (modal === 'nuevo') {
        await API.post('/mp/items', form);
        toast.success('✅ Ítem creado');
      } else {
        await API.put(`/mp/items/${modal.id}`, form);
        toast.success('✅ Ítem actualizado');
      }
      setModal(null);
      cargar();
    } catch(e) { toast.error(e.response?.data?.error || 'Error guardando'); }
    finally { setGuardando(false); }
  };

  const handleToggle = async (item) => {
    try {
      await API.put(`/mp/items/${item.id}`, { ...item, activo: !item.activo });
      toast.success(item.activo ? 'Ítem desactivado' : 'Ítem activado');
      cargar();
    } catch { toast.error('Error actualizando'); }
  };

  const filtrado = items.filter(i => !busqueda || i.nombre.toLowerCase().includes(busqueda.toLowerCase()) || i.categoria.toLowerCase().includes(busqueda.toLowerCase()));

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input placeholder="🔍 Buscar ítem..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{ ...st.input, flex: 1 }} />
        <button onClick={() => abrirModal(null)} style={{ padding: '9px 18px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#1a1a2e,#16213e)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700, whiteSpace: 'nowrap' }}>
          ➕ Nuevo ítem
        </button>
      </div>

      {categorias.map(cat => {
        const its = filtrado.filter(i => i.categoria === cat);
        if (!its.length) return null;
        return (
          <div key={cat} style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', marginBottom: 14 }}>
            <div style={{ background: '#F3F4F6', padding: '10px 18px', fontWeight: 700, fontSize: 13, color: '#374151', borderBottom: '1px solid #E5E7EB' }}>
              📁 {cat} <span style={{ fontWeight: 400, color: '#9CA3AF', fontSize: 12 }}>({its.length} ítems)</span>
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#F9FAFB' }}>
                  {['Código', 'Nombre', 'Unidad', 'Estado', 'Acciones'].map(h => (
                    <th key={h} style={{ padding: '9px 14px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {its.map((item, i) => (
                  <tr key={item.id} style={{ borderTop: '1px solid #F3F4F6', background: !item.activo ? '#FFF7F7' : i % 2 === 0 ? 'white' : '#FAFAFA' }}>
                    <td style={{ padding: '9px 14px', color: '#9CA3AF', fontSize: 12, fontFamily: 'monospace' }}>{item.codigo || '—'}</td>
                    <td style={{ padding: '9px 14px', fontWeight: 600, color: item.activo ? '#111827' : '#9CA3AF' }}>{item.nombre}</td>
                    <td style={{ padding: '9px 14px', color: '#6B7280' }}>{item.unidad}</td>
                    <td style={{ padding: '9px 14px' }}>
                      <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 700, background: item.activo ? '#D1FAE5' : '#FEE2E2', color: item.activo ? '#065F46' : '#991B1B' }}>
                        {item.activo ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                    <td style={{ padding: '9px 14px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => abrirModal(item)} style={{ padding: '4px 10px', border: '1px solid #E5E7EB', borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: '#374151' }}>✏️ Editar</button>
                        <button onClick={() => handleToggle(item)} style={{ padding: '4px 10px', border: `1px solid ${item.activo ? '#FCA5A5' : '#BBF7D0'}`, borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: item.activo ? '#EF4444' : '#059669' }}>
                          {item.activo ? '⏸ Desactivar' : '▶ Activar'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}

      {/* Modal */}
      {modal !== null && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: 16, padding: 28, width: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 20 }}>{modal === 'nuevo' ? '➕ Nuevo ítem' : '✏️ Editar ítem'}</div>
            {[
              { key: 'nombre', label: 'Nombre', placeholder: 'Ej: Azúcar refinada', auto: true },
              { key: 'categoria', label: 'Categoría', placeholder: 'Ej: Ingredientes base' },
              { key: 'unidad', label: 'Unidad de medida', placeholder: 'Ej: kg, lt, Caja' },
              { key: 'codigo', label: 'Código (opcional)', placeholder: 'Ej: ING-001' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 14 }}>
                <div style={st.label}>{f.label}</div>
                <input value={form[f.key]} onChange={e => setForm(fm => ({ ...fm, [f.key]: e.target.value }))}
                  placeholder={f.placeholder} autoFocus={f.auto}
                  style={{ ...st.input, width: '100%', boxSizing: 'border-box' }} />
              </div>
            ))}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setModal(null)} style={{ padding: '9px 18px', border: '2px solid #E5E7EB', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#6B7280' }}>Cancelar</button>
              <button onClick={handleGuardar} disabled={guardando} style={{ padding: '9px 20px', border: 'none', borderRadius: 10, background: 'linear-gradient(135deg,#1a1a2e,#16213e)', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {guardando ? '⏳ Guardando...' : modal === 'nuevo' ? '✅ Crear ítem' : '✅ Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const st = {
  label: { fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4, display: 'block' },
  input: { padding: '8px 12px', border: '2px solid #E5E7EB', borderRadius: 8, fontSize: 13, outline: 'none', background: 'white' },
};

// ── Pestaña Facturas ─────────────────────────────────────
function TabFacturas() {
  const hoy = format(new Date(), 'yyyy-MM-dd');
  const [items, setItems]         = useState([]);
  const [facturas, setFacturas]   = useState([]);
  const [cargando, setCargando]   = useState(false);
  const [desde, setDesde]         = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'));
  const [hasta, setHasta]         = useState(hoy);
  const [modal, setModal]         = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [detalle, setDetalle]     = useState(null);

  const [form, setForm] = useState({
    proveedor_id: '', numero_factura: '', fecha: hoy, flete: '', notas: '',
    tipo_factura: 'Materia Prima', nit_receptor: '901955872'
  });
  const [lineas, setLineas] = useState([
    { item_id: '', unidades_compradas: '', precio_unitario: '', iva_pct: '0', presentacion: 'unidad', factor_conversion: '1' }
  ]);

  const COP2 = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Number(n)||0);

  const [proveedores, setProveedores] = useState([]);
  const [modalProv, setModalProv]     = useState(false);
  const [formProv, setFormProv]       = useState({ nombre:'', nit:'', telefono:'', contacto:'', ciudad:'' });

  useEffect(() => {
    API.get('/mp/items').then(r => setItems(r.data)).catch(() => {});
    API.get('/proveedores').then(r => setProveedores(r.data)).catch(() => {});
    cargar();
  }, []);

  const crearProveedor = async () => {
    if (!formProv.nombre) { toast.error('El nombre es requerido'); return; }
    try {
      const r = await API.post('/proveedores', formProv);
      setProveedores(p => [...p, r.data].sort((a,b) => a.nombre.localeCompare(b.nombre)));
      setForm(f => ({ ...f, proveedor_id: String(r.data.id) }));
      setModalProv(false);
      setFormProv({ nombre:'', nit:'', telefono:'', contacto:'', ciudad:'' });
      toast.success('Proveedor creado');
    } catch(e) { toast.error('Error al crear proveedor'); }
  };

  const cargar = () => {
    setCargando(true);
    API.get('/mp/facturas', { params: { desde, hasta } })
      .then(r => setFacturas(r.data))
      .catch(() => toast.error('Error cargando facturas'))
      .finally(() => setCargando(false));
  };

  const PRESENTACIONES = [
    { label: 'Unidad', value: 'unidad', factor: 1 },
    { label: 'Bulto 25 kg', value: 'bulto_25', factor: 25 },
    { label: 'Bulto 50 kg', value: 'bulto_50', factor: 50 },
    { label: 'Personalizado', value: 'custom', factor: null },
  ];
  const addLinea = () => setLineas(l => [...l, { item_id: '', unidades_compradas: '', precio_unitario: '', iva_pct: '0', presentacion: 'unidad', factor_conversion: '1' }]);
  const setPresentacion = (i, val) => {
    const pres = PRESENTACIONES.find(p => p.value === val);
    setLineas(l => l.map((x, j) => j !== i ? x : {
      ...x, presentacion: val,
      factor_conversion: pres?.factor !== null ? String(pres.factor) : x.factor_conversion
    }));
  };
  const remLinea = (i) => setLineas(l => l.filter((_, j) => j !== i));
  const setLinea = (i, k, v) => setLineas(l => l.map((x, j) => j === i ? { ...x, [k]: v } : x));

  const [editandoId, setEditandoId] = useState(null);

  const costoLinea = (l) => {
    const flete_por_linea = (parseFloat(form.flete)||0) / Math.max(lineas.length, 1);
    const unidades = parseFloat(l.unidades_compradas)||0;
    const factor = parseFloat(l.factor_conversion)||1;
    const cant_kg = unidades * factor;
    if (!cant_kg) return 0;
    const precio_iva = (parseFloat(l.precio_unitario)||0) * (1 + (parseFloat(l.iva_pct)||0)/100);
    return precio_iva / factor + flete_por_linea / cant_kg;
  };
  const cantidadBase = (l) => (parseFloat(l.unidades_compradas)||0) * (parseFloat(l.factor_conversion)||1);

  const totalFactura = lineas.reduce((s, l) => {
    const unidades = parseFloat(l.unidades_compradas)||0;
    const precio = parseFloat(l.precio_unitario)||0;
    const iva = parseFloat(l.iva_pct)||0;
    return s + unidades * precio * (1 + iva/100);
  }, 0) + (parseFloat(form.flete)||0);

  const abrirEditar = async (id) => {
    try {
      const r = await API.get(`/mp/facturas/${id}`);
      const f = r.data;
      setEditandoId(id);
      setForm({
        proveedor_id: String(f.proveedor_id||''), numero_factura: f.numero_factura||'',
        fecha: f.fecha?.slice(0,10)||hoy, flete: f.flete||'', notas: f.notas||'',
        tipo_factura: f.tipo_factura||'Materia Prima', nit_receptor: f.nit_receptor||'901955872'
      });
      setLineas((f.detalle||[]).map(d => ({
        item_id: String(d.item_id),
        unidades_compradas: d.unidades_compradas||d.cantidad,
        precio_unitario: d.precio_unitario,
        iva_pct: d.iva_pct||'0',
        presentacion: d.presentacion||'unidad',
        factor_conversion: d.factor_conversion||'1'
      })));
      setModal(true);
    } catch(e) { toast.error('Error al cargar la factura'); }
  };

  const recalcularNaN = async () => {
    try {
      const r = await API.post('/mp/facturas/recalcular');
      toast.success(`✅ ${r.data.facturas_recalculadas} facturas recalculadas`);
      cargar();
    } catch(e) { toast.error('Error al recalcular'); }
  };

  const guardar = async () => {
    if (!form.proveedor_id || !form.fecha) { toast.error('Selecciona un proveedor y una fecha'); return; }
    if (lineas.some(l => !l.item_id || !l.unidades_compradas || !l.precio_unitario)) {
      toast.error('Completa todas las líneas'); return;
    }
    setGuardando(true);
    try {
      if (editandoId) {
        await API.put(`/mp/facturas/${editandoId}`, { ...form, lineas });
        toast.success('✅ Factura actualizada');
      } else {
        await API.post('/mp/facturas', { ...form, lineas });
        toast.success('✅ Factura registrada y stock actualizado');
      }
      setModal(false);
      setEditandoId(null);
      setForm({ proveedor_id: '', numero_factura: '', fecha: hoy, flete: '', notas: '', tipo_factura: 'Materia Prima', nit_receptor: '901955872' });
      setLineas([{ item_id: '', unidades_compradas: '', precio_unitario: '', iva_pct: '0', presentacion: 'unidad', factor_conversion: '1' }]);
      cargar();
    } catch(e) { toast.error(e.response?.data?.error || 'Error al guardar'); }
    finally { setGuardando(false); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar factura? Se revertirá el stock.')) return;
    try {
      await API.delete(`/mp/facturas/${id}`);
      toast.success('Factura eliminada');
      cargar();
    } catch(e) { toast.error('Error al eliminar'); }
  };

  const verDetalle = async (id) => {
    const r = await API.get(`/mp/facturas/${id}`);
    setDetalle(r.data);
  };

  return (
    <div>
      {/* Controles */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div><span style={st.label}>Desde</span><input type="date" value={desde} onChange={e => setDesde(e.target.value)} style={st.input} /></div>
        <div><span style={st.label}>Hasta</span><input type="date" value={hasta} onChange={e => setHasta(e.target.value)} style={st.input} /></div>
        <button onClick={cargar} style={{ padding: '8px 18px', background: '#374151', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>Buscar</button>
        <button onClick={() => { setEditandoId(null); setModal(true); }} style={{ padding: '8px 18px', background: '#2563EB', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700, marginLeft: 'auto' }}>+ Nueva factura</button>
        <button onClick={recalcularNaN} style={{ padding: '8px 14px', background: '#F59E0B', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600 }} title="Recalcula facturas con costo $0">🔧 Recalcular</button>
      </div>

      {/* Lista facturas */}
      <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#F9FAFB' }}>
              {['Fecha', 'Proveedor', 'NIT receptor', 'Tipo', 'N° Factura', 'Líneas', 'Flete', 'Total', 'Acciones'].map(h => (
                <th key={h} style={{ padding: '10px 14px', textAlign: ['Líneas','Flete','Total'].includes(h) ? 'right' : 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {cargando ? (
              <tr><td colSpan={7} style={{ padding: 32, textAlign: 'center', color: '#9CA3AF' }}>Cargando...</td></tr>
            ) : facturas.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: 32, textAlign: 'center', color: '#9CA3AF' }}>Sin facturas en este período</td></tr>
            ) : facturas.map((f, i) => (
              <tr key={f.id} style={{ borderTop: '1px solid #F3F4F6', background: i%2===0?'white':'#FAFAFA' }}>
                <td style={{ padding: '10px 14px', color: '#374151' }}>{f.fecha?.slice(0,10)}</td>
                <td style={{ padding: '10px 14px', fontWeight: 600 }}>{f.proveedor}</td>
                <td style={{ padding: '10px 14px', fontSize: 11, color: '#6B7280' }}>
                  {f.nit_receptor === '901955872' ? 'Gelatus SAS' : f.nit_receptor === '1065002659' ? 'J. Ruiz' : f.nit_receptor === '1067924655' ? 'B. De Vargas' : '—'}
                </td>
                <td style={{ padding: '10px 14px' }}>
                  <span style={{ padding: '2px 8px', borderRadius: 6, fontSize: 11, fontWeight: 700, background: f.tipo_factura==='Materia Prima'?'#EFF6FF':f.tipo_factura==='Empaques'?'#F0FDF4':f.tipo_factura==='Aseo'?'#FEF3C7':'#F3F4F6', color: f.tipo_factura==='Materia Prima'?'#1D4ED8':f.tipo_factura==='Empaques'?'#065F46':f.tipo_factura==='Aseo'?'#92400E':'#374151' }}>
                    {f.tipo_factura||'Materia Prima'}
                  </span>
                </td>
                <td style={{ padding: '10px 14px', color: '#6B7280', fontFamily: 'monospace' }}>{f.numero_factura || '—'}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', color: '#6B7280' }}>{f.num_lineas}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', color: '#6B7280', fontFamily: 'monospace' }}>{f.flete > 0 ? COP2(f.flete) : '—'}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: '#2563EB' }}>{COP2(f.valor_total)}</td>
                <td style={{ padding: '10px 14px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => abrirEditar(f.id)} style={{ padding: '4px 10px', border: '1px solid #E5E7EB', borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 12 }}>✏️ Editar</button>
                    <button onClick={() => verDetalle(f.id)} style={{ padding: '4px 10px', border: '1px solid #E5E7EB', borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 12 }}>Ver</button>
                    <button onClick={() => eliminar(f.id)} style={{ padding: '4px 10px', border: '1px solid #FECACA', borderRadius: 6, background: 'white', color: '#EF4444', cursor: 'pointer', fontSize: 12 }}>Eliminar</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal nueva factura */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 820, maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ background: '#1a1a2e', padding: '16px 24px', borderRadius: '16px 16px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800, fontSize: 16 }}>{editandoId ? '✏️ Editar factura' : '🧾 Nueva factura de compra'}</span>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', color: 'white', fontSize: 20, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ padding: 24 }}>
              {/* Encabezado */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 20 }}>
                <div>
                  <span style={st.label}>Proveedor *</span>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <select value={form.proveedor_id} onChange={e => setForm(f => ({...f, proveedor_id: e.target.value}))}
                      style={{...st.input, flex: 1}}>
                      <option value="">Seleccionar...</option>
                      {proveedores.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
                    </select>
                    <button onClick={() => setModalProv(true)} title="Nuevo proveedor"
                      style={{ padding: '8px 10px', border: '2px solid #E5E7EB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 16 }}>+</button>
                  </div>
                </div>
                <div><span style={st.label}>N° Factura</span>
                  <input value={form.numero_factura} onChange={e => setForm(f => ({...f, numero_factura: e.target.value}))} placeholder="Opcional" style={{...st.input, width: '100%', boxSizing: 'border-box'}} /></div>
                <div><span style={st.label}>Fecha *</span>
                  <input type="date" value={form.fecha} onChange={e => setForm(f => ({...f, fecha: e.target.value}))} style={{...st.input, width: '100%', boxSizing: 'border-box'}} /></div>
                <div><span style={st.label}>Flete ($)</span>
                  <input type="number" value={form.flete} onChange={e => setForm(f => ({...f, flete: e.target.value}))} placeholder="0" style={{...st.input, width: '100%', boxSizing: 'border-box'}} /></div>
                <div>
                  <span style={st.label}>Tipo de factura</span>
                  <select value={form.tipo_factura} onChange={e => setForm(f=>({...f,tipo_factura:e.target.value}))} style={{...st.input,width:'100%',boxSizing:'border-box'}}>
                    <option value="Materia Prima">Materia Prima</option>
                    <option value="Empaques">Empaques</option>
                    <option value="Aseo">Aseo</option>
                    <option value="Papelería">Papelería</option>
                    <option value="Otros">Otros</option>
                  </select>
                </div>
                <div>
                  <span style={st.label}>NIT receptor</span>
                  <select value={form.nit_receptor} onChange={e => setForm(f=>({...f,nit_receptor:e.target.value}))} style={{...st.input,width:'100%',boxSizing:'border-box'}}>
                    <option value="901955872">Gelatus Colombia SAS · 901.955.872</option>
                    <option value="1065002659">Jhon Jesús Ruiz · 1.065.002.659</option>
                    <option value="1067924655">Betty De Vargas · 1.067.924.655</option>
                  </select>
                </div>
                <div style={{ gridColumn: 'span 2' }}><span style={st.label}>Notas</span>
                  <input value={form.notas} onChange={e => setForm(f => ({...f, notas: e.target.value}))} placeholder="Opcional" style={{...st.input, width: '100%', boxSizing: 'border-box'}} /></div>
              </div>

              {/* Líneas */}
              <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 10, color: '#374151' }}>Ítems de la factura</div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 10 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Ítem *', 'Presentación', 'Cant. bultos *', 'Factor kg', 'Total kg', 'Precio/bulto *', 'IVA %', 'Costo/kg', ''].map(h => (
                      <th key={h} style={{ padding: '8px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {lineas.map((l, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                      <td style={{ padding: '6px 6px' }}>
                        <select value={l.item_id} onChange={e => setLinea(i, 'item_id', e.target.value)} style={{ ...st.input, width: 160 }}>
                          <option value="">Seleccionar...</option>
                          {items.map(it => <option key={it.id} value={it.id}>{it.nombre} ({it.unidad})</option>)}
                        </select>
                      </td>
                      <td style={{ padding: '6px 6px' }}>
                        <select value={l.presentacion} onChange={e => setPresentacion(i, e.target.value)} style={{ ...st.input, width: 110 }}>
                          {PRESENTACIONES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                        </select>
                      </td>
                      <td style={{ padding: '6px 6px' }}>
                        <input type="number" value={l.unidades_compradas} onChange={e => setLinea(i, 'unidades_compradas', e.target.value)} placeholder="0" style={{ ...st.input, width: 70 }} />
                      </td>
                      <td style={{ padding: '6px 6px' }}>
                        {l.presentacion === 'custom'
                          ? <input type="number" value={l.factor_conversion} onChange={e => setLinea(i, 'factor_conversion', e.target.value)} placeholder="kg/bulto" style={{ ...st.input, width: 70 }} />
                          : <span style={{ color: '#6B7280', fontSize: 13, padding: '0 8px' }}>{l.factor_conversion}</span>
                        }
                      </td>
                      <td style={{ padding: '6px 6px', fontFamily: 'monospace', color: '#374151', fontWeight: 700 }}>
                        {cantidadBase(l) > 0 ? `${cantidadBase(l)} ${items.find(it => String(it.id) === String(l.item_id))?.unidad || ''}` : '—'}
                      </td>
                      <td style={{ padding: '6px 6px' }}>
                        <input type="number" value={l.precio_unitario} onChange={e => setLinea(i, 'precio_unitario', e.target.value)} placeholder="0" style={{ ...st.input, width: 100 }} />
                      </td>
                      <td style={{ padding: '6px 6px' }}>
                        <select value={l.iva_pct} onChange={e => setLinea(i, 'iva_pct', e.target.value)} style={{ ...st.input, width: 65 }}>
                          <option value="0">0%</option>
                          <option value="5">5%</option>
                          <option value="19">19%</option>
                        </select>
                      </td>
                      <td style={{ padding: '6px 6px', fontFamily: 'monospace', color: '#2563EB', fontWeight: 700, whiteSpace: 'nowrap' }}>
                        {costoLinea(l) > 0 ? `$${new Intl.NumberFormat('es-CO').format(costoLinea(l).toFixed(0))}/kg` : '—'}
                      </td>
                      <td style={{ padding: '6px 6px' }}>
                        {lineas.length > 1 && <button onClick={() => remLinea(i)} style={{ background: 'none', border: 'none', color: '#EF4444', cursor: 'pointer', fontSize: 16 }}>×</button>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button onClick={addLinea} style={{ padding: '6px 14px', border: '2px dashed #D1D5DB', borderRadius: 8, background: 'white', cursor: 'pointer', fontSize: 13, color: '#6B7280', marginBottom: 20 }}>+ Agregar ítem</button>

              {/* Total */}
              <div style={{ background: '#EFF6FF', borderRadius: 10, padding: '12px 16px', marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 700, color: '#1E40AF' }}>Total factura (con IVA + flete)</span>
                <span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 18, color: '#2563EB' }}>{COP2(totalFactura)}</span>
              </div>

              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => setModal(false)} style={{ padding: '10px 22px', border: '2px solid #E5E7EB', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>Cancelar</button>
                <button onClick={guardar} disabled={guardando} style={{ padding: '10px 28px', background: 'linear-gradient(135deg,#2563EB,#1D4ED8)', color: 'white', border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>
                  {guardando ? '⏳ Guardando...' : '💾 Guardar factura'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal nuevo proveedor */}
      {modalProv && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 460 }}>
            <div style={{ background: '#1a1a2e', padding: '14px 22px', borderRadius: '16px 16px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800 }}>🏭 Nuevo proveedor</span>
              <button onClick={() => setModalProv(false)} style={{ background: 'none', border: 'none', color: 'white', fontSize: 20, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div><span style={st.label}>Nombre *</span><input value={formProv.nombre} onChange={e => setFormProv(f=>({...f,nombre:e.target.value}))} placeholder="Nombre o razón social" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div><span style={st.label}>NIT</span><input value={formProv.nit} onChange={e => setFormProv(f=>({...f,nit:e.target.value}))} placeholder="900.000.000-0" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
                <div><span style={st.label}>Ciudad</span><input value={formProv.ciudad} onChange={e => setFormProv(f=>({...f,ciudad:e.target.value}))} placeholder="Ciudad" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
                <div><span style={st.label}>Teléfono</span><input value={formProv.telefono} onChange={e => setFormProv(f=>({...f,telefono:e.target.value}))} placeholder="Teléfono" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
                <div><span style={st.label}>Contacto</span><input value={formProv.contacto} onChange={e => setFormProv(f=>({...f,contacto:e.target.value}))} placeholder="Nombre del contacto" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
              </div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 6 }}>
                <button onClick={() => setModalProv(false)} style={{ padding: '9px 18px', border: '2px solid #E5E7EB', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
                <button onClick={crearProveedor} style={{ padding: '9px 24px', border: 'none', borderRadius: 10, background: '#2563EB', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>Crear y seleccionar</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal detalle factura */}
      {detalle && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 680, maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ background: '#1a1a2e', padding: '14px 22px', borderRadius: '16px 16px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800 }}>🧾 Factura {detalle.numero_factura || `#${detalle.id}`} — {detalle.proveedor}</span>
              <button onClick={() => setDetalle(null)} style={{ background: 'none', border: 'none', color: 'white', fontSize: 20, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ padding: 22 }}>
              <div style={{ display: 'flex', gap: 20, marginBottom: 16, fontSize: 13 }}>
                <div><span style={{ color: '#9CA3AF' }}>Fecha: </span><strong>{detalle.fecha?.slice(0,10)}</strong></div>
                <div><span style={{ color: '#9CA3AF' }}>Flete: </span><strong>{COP2(detalle.flete)}</strong></div>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    {['Ítem', 'Unidad', 'Cantidad', 'Precio unit.', 'IVA', 'Costo unit. final'].map(h => (
                      <th key={h} style={{ padding: '9px 12px', textAlign: ['Cantidad','Precio unit.','Costo unit. final'].includes(h) ? 'right' : 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {detalle.detalle?.map((d, i) => (
                    <tr key={d.id} style={{ borderTop: '1px solid #F3F4F6', background: i%2===0?'white':'#FAFAFA' }}>
                      <td style={{ padding: '9px 12px', fontWeight: 600 }}>{d.item_nombre}</td>
                      <td style={{ padding: '9px 12px', color: '#9CA3AF' }}>{d.unidad}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace' }}>{COP(d.cantidad)}</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace' }}>{COP2(d.precio_unitario)}</td>
                      <td style={{ padding: '9px 12px', color: '#9CA3AF' }}>{d.iva_pct}%</td>
                      <td style={{ padding: '9px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 800, color: '#2563EB' }}>{COP2(d.costo_unitario_final)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Pestaña Proveedores ──────────────────────────────────
function TabProveedores() {
  const [proveedores, setProveedores] = useState([]);
  const [modal, setModal]             = useState(false);
  const [editando, setEditando]       = useState(null);
  const [form, setForm] = useState({ nombre:'', nit:'', telefono:'', contacto:'', ciudad:'', notas:'' });
  const [guardando, setGuardando]     = useState(false);
  const [busqueda, setBusqueda]       = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    API.get('/proveedores').then(r => setProveedores(r.data)).catch(() => {});
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombre:'', nit:'', telefono:'', contacto:'', ciudad:'', notas:'' });
    setModal(true);
  };

  const abrirEditar = (p) => {
    setEditando(p.id);
    setForm({ nombre: p.nombre, nit: p.nit||'', telefono: p.telefono||'', contacto: p.contacto||'', ciudad: p.ciudad||'', notas: p.notas||'' });
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre) { toast.error('El nombre es requerido'); return; }
    setGuardando(true);
    try {
      if (editando) {
        await API.put(`/proveedores/${editando}`, form);
        toast.success('Proveedor actualizado');
      } else {
        await API.post('/proveedores', form);
        toast.success('Proveedor creado');
      }
      setModal(false);
      cargar();
    } catch(e) { toast.error('Error al guardar'); }
    finally { setGuardando(false); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Desactivar este proveedor?')) return;
    try {
      await API.delete(`/proveedores/${id}`);
      toast.success('Proveedor desactivado');
      cargar();
    } catch(e) { toast.error('Error al desactivar'); }
  };

  const filtrados = proveedores.filter(p =>
    p.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
    (p.nit||'').includes(busqueda) ||
    (p.ciudad||'').toLowerCase().includes(busqueda.toLowerCase())
  );

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input value={busqueda} onChange={e => setBusqueda(e.target.value)} placeholder="Buscar proveedor..." style={{ ...st.input, width: 260 }} />
        <button onClick={abrirNuevo} style={{ padding: '8px 18px', background: '#2563EB', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700, marginLeft: 'auto' }}>+ Nuevo proveedor</button>
      </div>

      <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.07)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#F9FAFB' }}>
              {['Nombre', 'NIT', 'Ciudad', 'Teléfono', 'Contacto', 'Facturas', ''].map(h => (
                <th key={h} style={{ padding: '10px 14px', textAlign: h === 'Facturas' ? 'right' : 'left', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: 32, textAlign: 'center', color: '#9CA3AF' }}>
                {busqueda ? 'Sin resultados' : 'No hay proveedores registrados'}
              </td></tr>
            ) : filtrados.map((p, i) => (
              <tr key={p.id} style={{ borderTop: '1px solid #F3F4F6', background: i%2===0?'white':'#FAFAFA' }}>
                <td style={{ padding: '10px 14px', fontWeight: 700 }}>{p.nombre}</td>
                <td style={{ padding: '10px 14px', color: '#6B7280', fontFamily: 'monospace' }}>{p.nit || '—'}</td>
                <td style={{ padding: '10px 14px', color: '#6B7280' }}>{p.ciudad || '—'}</td>
                <td style={{ padding: '10px 14px', color: '#6B7280' }}>{p.telefono || '—'}</td>
                <td style={{ padding: '10px 14px', color: '#6B7280' }}>{p.contacto || '—'}</td>
                <td style={{ padding: '10px 14px', textAlign: 'right', color: '#374151' }}>{p.total_facturas || 0}</td>
                <td style={{ padding: '10px 14px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={() => abrirEditar(p)} style={{ padding: '4px 10px', border: '1px solid #E5E7EB', borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 12 }}>✏️ Editar</button>
                    <button onClick={() => eliminar(p.id)} style={{ padding: '4px 10px', border: '1px solid #FECACA', borderRadius: 6, background: 'white', color: '#EF4444', cursor: 'pointer', fontSize: 12 }}>Desactivar</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 500 }}>
            <div style={{ background: '#1a1a2e', padding: '14px 22px', borderRadius: '16px 16px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: 'white', fontWeight: 800 }}>🏭 {editando ? 'Editar proveedor' : 'Nuevo proveedor'}</span>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', color: 'white', fontSize: 20, cursor: 'pointer' }}>×</button>
            </div>
            <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div><span style={st.label}>Nombre *</span><input value={form.nombre} onChange={e => setForm(f=>({...f,nombre:e.target.value}))} placeholder="Nombre o razón social" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div><span style={st.label}>NIT</span><input value={form.nit} onChange={e => setForm(f=>({...f,nit:e.target.value}))} placeholder="900.000.000-0" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
                <div><span style={st.label}>Ciudad</span><input value={form.ciudad} onChange={e => setForm(f=>({...f,ciudad:e.target.value}))} placeholder="Ciudad" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
                <div><span style={st.label}>Teléfono</span><input value={form.telefono} onChange={e => setForm(f=>({...f,telefono:e.target.value}))} placeholder="Teléfono" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
                <div><span style={st.label}>Contacto</span><input value={form.contacto} onChange={e => setForm(f=>({...f,contacto:e.target.value}))} placeholder="Nombre del contacto" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
              </div>
              <div><span style={st.label}>Notas</span><input value={form.notas} onChange={e => setForm(f=>({...f,notas:e.target.value}))} placeholder="Observaciones opcionales" style={{...st.input,width:'100%',boxSizing:'border-box'}} /></div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 6 }}>
                <button onClick={() => setModal(false)} style={{ padding: '9px 18px', border: '2px solid #E5E7EB', borderRadius: 10, background: 'white', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
                <button onClick={guardar} disabled={guardando} style={{ padding: '9px 24px', border: 'none', borderRadius: 10, background: '#2563EB', color: 'white', cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                  {guardando ? '⏳' : editando ? '💾 Actualizar' : '💾 Crear'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
